<div [class]="classItem">
  <div class="flex justify-between text-xs text-gray-700 font-bold">
    <div>#{{ invoice.id }}</div>
    <div>{{ invoiceStatus.name }}</div>
    <div class="uppercase">{{ invoice.form_of_payment.name }}</div>
  </div>

  <div class="text-xs">
    {{ invoice.description }}
  </div>

  <div class="flex justify-between">
    <div>{{ invoice.due_date | date:'dd/MM/yyyy' }}</div>
    <div>{{ invoice.final_value | currency:'BRL' }}</div>
    <div>Parc:{{ invoice.quota_number }} / <span class="text-xs">{{ invoice.quota_total }}</span></div>
  </div>

  <div
    class="flex justify-between font-bold"
    *ngIf="invoice.payment_date"
  >
    <div>Pago em</div>
    <div>{{ invoice.payment_date | date:'dd/MM/yyyy' }}</div>
    <div>{{ invoice.payed_value | currency:'BRL' }}</div>
  </div>

  <div class="flex gap-1 justify-center font-bold">
    <button
      *ngIf="invoice.ticket?.document_number"
      class="flex gap-1 bg-cyan-700 hover:bg-cyan-800 px-2 py-1
      text-xs rounded font-semibold text-white"
      (click)="openBill()"
    >
      <mat-icon [inline]="true">request_quote</mat-icon>
      Boleto
    </button>

    <button
      *ngIf="invoice.sell"
      class="flex gap-1 bg-yellow-700 hover:bg-yellow-800 px-2 py-1
      text-xs rounded font-semibold text-white"
      (click)="openSell()"
    >
      <mat-icon [inline]="true">sell</mat-icon>
      Venda
    </button>
  </div>
</div>
